import React, { useState } from "react";
import PropTypes from "prop-types";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import HeroAccount from "../../sections/hero-account";
import "./style.scss";
import Heading from "../../elements/heading";
import BodyText from "../../elements/body-text";
import PrimaryButton from "../../elements/primary-button";
import Summary from "../../sections/summary";
import LoginForm from "../../sections/login-form";
import { S_AUTH_TOKEN, S_USER, webStorage } from "../../utils/webStorage";
import { getEncryptor } from "../../services/siteService";
import { getToken, getUserInfo } from "../../services/userService";
import api from "../../utils/api";
import { withRouter } from "react-router-dom";
import { LOGOUT, setUserInfoAction } from "../../redux/actions";
import { connect } from "react-redux";
import SimpleLink from "../../elements/simple-link";
import { authProvider } from "../../services/authProvider";
import { AzureAD, AuthenticationState } from "react-aad-msal";
import store from "../../redux/store/store";
import InStoreLoginForm from "../../sections/in-store-login-form";
import { canUseDOM } from "../../utils";
import AccordionWrapper from "../../elements/accordion-wrapper";
import { getMembershipLevel } from "../../utils/measurements";

let submitting = false;
function BecomeAMemberSummary({ hero, summary, info, login, setUserInfo, logout, lang, match, id, history }) {
  const [loginFailed, setLoginFailed] = useState(null);
  const [loginNetworkError, setLoginNetworkError] = useState(null);
  const [loginAccountLock, setLoginAccountLock] = useState(null);
  const [loginWrongEmailOrPassword, setLoginWrongEmailOrPassword] = useState(null);
  const [inStoreMemberNotFound, setInStoreMemberNotFound] = useState(false);

  const submitLogin = async (evt, data) => {
    setLoginFailed(false);
    setLoginNetworkError(false);
    setLoginAccountLock(false);
    setLoginWrongEmailOrPassword(false);
    try {
      const token = await getToken(data.email, data.password, lang);
      webStorage.set(S_AUTH_TOKEN, {
        ...token,
        loginTime: new Date().getTime()
      });
      try {
        const user = await getUserInfo();
        setUserInfo(user);
        setLoginFailed(false);
        if (login.nextPageUrl.value) {
          login.goNextStep(login.nextPageUrl.value.href, user);
        }
        //** Measurements */
        let dataLayer = window.dataLayer || [];
        const membershipLevel = getMembershipLevel(summary.details.membership.membership.code);
        dataLayer.push({
          event: "accountLogin",
          eventCategory: "account",
          eventAction: "login",
          eventLabel: membershipLevel
        });
      } catch (ex) {
        if (ex.status && ex.status !== 200) {
          setLoginNetworkError(true);
        } else {
          if (ex.code === "USER_CUSTOMER_0003") {
            setLoginWrongEmailOrPassword(true);
          } else {
            setLoginFailed(true);
          }
        }
      }
    } catch (ex) {
      if (ex.status && ex.status !== 200) {
        setLoginNetworkError(true);
      } else if (ex.code === "ECOMMERCE_GATEWAY_0002") {
        if (ex.obj.state === "LOCK") {
          setLoginAccountLock(true);
        } else {
          setLoginWrongEmailOrPassword(true);
        }
      } else {
        setLoginFailed(true);
      }
    }
  };
  const submitLoginInStore = async (evt, data, staffAccountDetails) => {
    if (!submitting) {
      submitting = true;
      setInStoreMemberNotFound(false);
      const { obj } = await api.email.getUser({
        email: data.email
      });
      if (obj) {
        setUserInfo(obj);
        if (login.nextPageUrl.value) {
          login.goNextStep(login.nextPageUrl.value.href, obj);
        }
      } else {
        setInStoreMemberNotFound(true);
      }
      submitting = false;
    }
  };
  const onLogoutClick = () => {
    logout();
    if (login.redirectUrlAfterLogout.value) {
      let newUrl = `${login.redirectUrlAfterLogout.value.href}?redirect=${encodeURIComponent(login.nextPageUrl.value.href)}`;
      login.history.replace(newUrl);
    } else {
      login.history.push("/");
    }
  };
  return (
    <div className="become-a-member-summary grid" id={id}>
      <HeroAccount {...hero} />

      {summary.showSummary && (
        <div className="summary-container-desktop">
          <Summary {...{ ...summary, match: match }} />
        </div>
      )}

      {summary.showSummary && (
        <div className="summary-container-mobile">
          <AccordionWrapper heading={summary.text.heading}>
            <Summary
              {...{
                ...summary,
                text: { ...summary.text, heading: null },
                match: match
              }}
            />
          </AccordionWrapper>
        </div>
      )}

      <div className="info">
        <Heading {...info.heading} typographyClass="type-h2" className="title" />
        <BodyText html={info.body} />
        {login.user && (
          <div className="button-container">
            <PrimaryButton
              {...login.cta}
              callback={() => {
                login.setSummary();
                login.goNextStep(login.nextPageUrl.value.href);
              }}
            />
            {info.error && <RichText tag="div" className="warning-message" field={{ value: info.error }} />}
            <SimpleLink
              className="logout"
              text={login.logoutButtonText.value}
              callback={() => {
                onLogoutClick();
                login.setSummary();
              }}
            />
          </div>
        )}
        {!login.showLoginForm.value && !login.user && (
          <div>
            <PrimaryButton {...info.cta} />
            {info.error && <RichText tag="div" className="warning-message" field={{ value: info.error }} />}
          </div>
        )}

        {canUseDOM() && login.showLoginForm.value && !login.user && (
          <>
            <AzureAD provider={authProvider} reduxStore={store}>
              {({ accountInfo, authenticationState }) => {
                return (
                  <React.Fragment>
                    {authenticationState === AuthenticationState.Unauthenticated && (
                      <>
                        <section className="create-account">
                          <Heading type={login.createAccountHeadingType} className="title" html={login.createAccountHeadingBody} typographyClass="type-h3" />
                          <PrimaryButton
                            {...{ ...login.createAccountButton.fields }}
                            callback={() => {
                              login.setSummary();
                              history.replace(login?.createAccountButton?.fields?.link?.value?.href || `/${lang}`);
                            }}
                          />
                        </section>
                        <section className="login-container">
                          <LoginForm
                            {...{
                              ...login.loginForm.fields,
                              loginFailed,
                              loginNetworkError,
                              loginAccountLock,
                              loginWrongEmailOrPassword,
                              submitLogin: (evt, data) => {
                                submitLogin(evt, data);
                              },
                              lang,
                              match
                            }}
                          />
                        </section>
                      </>
                    )}

                    {authenticationState === AuthenticationState.Authenticated && (
                      <>
                        <section className="create-account">
                          <Heading type={login.createAccountHeadingType} className="title" html={login.createAccountHeadingBody} typographyClass="type-h3" />
                          <PrimaryButton
                            {...{ ...login.createAccountButton.fields }}
                            callback={() => {
                              login.setSummary();
                              history.replace(login?.createAccountButton?.fields?.link?.value?.href || `/${lang}`);
                            }}
                          />
                        </section>

                        <InStoreLoginForm
                          {...{
                            ...login.inStoreLoginForm?.fields,
                            loginFailed,
                            loginNetworkError,
                            loginAccountLock,
                            inStoreMemberNotFound,
                            onContinue: (evt, data) => submitLoginInStore(evt, data, accountInfo)
                          }}
                        />
                      </>
                    )}
                  </React.Fragment>
                );
              }}
            </AzureAD>
          </>
        )}
      </div>
    </div>
  );
}

BecomeAMemberSummary.propTypes = {
  hero: PropTypes.object,
  info: PropTypes.object,
  summary: PropTypes.object,
  login: PropTypes.shape({
    showLoginForm: PropTypes.object,
    createAccountHeadingType: PropTypes.object,
    createAccountHeadingBody: PropTypes.object,
    createAccountButton: PropTypes.object,
    loginForm: PropTypes.object,
    loginSuccessRedirectUrl: PropTypes.object,
    history: PropTypes.object,
    lang: PropTypes.string,
    defaultRedirect: PropTypes.object,
    user: PropTypes.object
  })
};

const mapDispatchToProps = dispatch => ({
  setUserInfo: data => {
    dispatch(setUserInfoAction(data));
  },
  logout: (...args) => dispatch({ type: LOGOUT, ...args })
});

export default withRouter(connect(null, mapDispatchToProps)(BecomeAMemberSummary));
